import { Dialog, dialogClasses } from '@mui/material';
import authService from '#services/auth';
import {
  ForcedSignOutDialogBody,
  ForcedSignOutDialogBodyProps,
} from '../shared/ForcedSignOutDialogBody';

type ForcedSignOutDialogProps = ForcedSignOutDialogBodyProps & {
  open?: boolean;
};

export const ForcedSignOutDialog = (props: ForcedSignOutDialogProps) => {
  const { open = false, ...rest } = props;

  return (
    <Dialog
      open={open}
      sx={{
        [`.${dialogClasses.paper}`]: {
          width: 256,
        },
      }}
    >
      <ForcedSignOutDialogBody
        {...rest}
        onClose={() => {
          authService.logout(false);
        }}
      />
    </Dialog>
  );
};
